import { parse } from 'bowser';
export const fetchOS = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const userAgent = window.navigator.userAgent;

  return parse(userAgent).os;
};
